import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat-map";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import { computed } from "@vue/composition-api";
import { useVuelidate } from "@vuelidate/core";
import { additionalIncomeBindingsAndVisibilities } from "@Client/@Composables/application-standalone/pages/income-history/additionalIncomeBindingsAndVisibilities";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { getValidationRulesFromMap } from "@Client/@Composables/application-standalone/validations/getValidationRulesFromMap";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import { camelCase, capitalize, mapKeys } from "lodash";
export const additionalIncomeValidator = (applicantIndex, incomeIndex, {
  lazy = false
} = {}) => {
  const {
    bindings
  } = additionalIncomeBindingsAndVisibilities(applicantIndex, incomeIndex);
  const {
    additionalIncomeAmount,
    additionalIncomeDescription,
    additionalIncomeIncomePeriod,
    additionalIncomeType
  } = bindings;
  const applicantPrefix = computed(() => {
    return applicantIndex.value ? "applicant" : "";
  });
  const {
    GET_SCHEMA_RULES_BY_PATH,
    HAS_CONSOLIDATED_REQUEST
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_SCHEMA_RULES_BY_PATH, ApplicationStandaloneGetters.HAS_CONSOLIDATED_REQUEST]);
  const {
    isApplicantVisibleFromFillOut,
    getApplicantIdByIndex
  } = useApplicantHelpers();
  const areRulesVisibleFromFillOut = () => !HAS_CONSOLIDATED_REQUEST.value || isApplicantVisibleFromFillOut(getApplicantIdByIndex(applicantIndex.value));
  const rules = computed(() => {
    return getValidationRulesFromMap(areRulesVisibleFromFillOut, GET_SCHEMA_RULES_BY_PATH, additionalIncomePageRules, applicantPrefix.value);
  });
  const v$ = useVuelidate(rules, {
    additionalIncomeAmount,
    additionalIncomeDescription,
    additionalIncomeIncomePeriod,
    additionalIncomeType
  }, {
    $scope: true,
    $lazy: lazy
  });
  return {
    v$
  };
};
const additionalIncomePageRules = {
  additionalIncomeAmount: {},
  additionalIncomeDescription: {},
  additionalIncomeIncomePeriod: {},
  additionalIncomeType: {}
};
export const additionalIncomesValidator = ({
  lazy = false
} = {}) => {
  const {
    allAdditionalIncomes: additionalIncomes
  } = useApplicantHelpers();
  const {
    GET_SCHEMA_RULES_BY_PATH,
    HAS_CONSOLIDATED_REQUEST
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_SCHEMA_RULES_BY_PATH, ApplicationStandaloneGetters.HAS_CONSOLIDATED_REQUEST]);
  const {
    isApplicantVisibleFromFillOut
  } = useApplicantHelpers();
  const areRulesVisibleFromFillOut = ({
    id,
    applicantId
  }) => !HAS_CONSOLIDATED_REQUEST.value || isApplicantVisibleFromFillOut(id || applicantId);
  const allAdditionalIncomes = computed(() => {
    var _context;
    return _flatMapInstanceProperty(_context = additionalIncomes.value).call(_context, item => areRulesVisibleFromFillOut(item) ? mapKeys(item, (_value, key) => camelCase("additionalIncome" + capitalize(key))) : []);
  });
  const getRules = () => {
    var _context2;
    const mainApplicantRules = getValidationRulesFromMap(() => true, GET_SCHEMA_RULES_BY_PATH, additionalIncomePageRules);
    const coApplicantRules = getValidationRulesFromMap(() => true, GET_SCHEMA_RULES_BY_PATH, additionalIncomePageRules, "applicant");
    return _reduceInstanceProperty(_context2 = allAdditionalIncomes.value).call(_context2, (acc, _asset, index) => {
      acc[index] = _asset.applicantIndex ? coApplicantRules : mainApplicantRules;
      return acc;
    }, {});
  };
  const rules = computed(getRules);
  const v$ = useVuelidate(rules, allAdditionalIncomes, {
    $scope: "additionalIncome",
    $lazy: lazy
  });
  return {
    v$
  };
};